import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';
import Hint from '@components/basics/hint';

import styled from 'styled-components';
import InputField from '@components/form/input';

// Store
import AppState from '@webapp/store/state';
import {
  ChangeReleaseInputField,
  UpdateField,
} from '@webapp/store/release/action-creators';

//utils
import { isRecordLabelNameValid } from '@webapp/utils/record-labels/is-record-label-name-valid';

interface RecordLabelCtrlProps {
  className?: string;
  recordLabel: string;
  trackRecordLabelField: (
    recordLabel: string
  ) => ChangeReleaseInputField<'recordLabel'>;
  updateRecordLabelField: (recordLabel: string) => UpdateField<'recordLabel'>;
}

const mapStateToProps = (state: AppState) => ({
  recordLabel: state.release.release?.recordLabel || '',
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateRecordLabelField: (recordLabel: string) =>
    dispatch(
      new UpdateField<'recordLabel'>(
        'recordLabel',
        recordLabel.trim(),
        undefined,
        true
      )
    ),
  trackRecordLabelField: (recordLabel: string) =>
    dispatch(
      new ChangeReleaseInputField<'recordLabel'>(
        'recordLabel',
        recordLabel.trim()
      )
    ),
});

export const RecordLabelCtrl: React.FC<RecordLabelCtrlProps> = ({
  className,
  recordLabel,
  updateRecordLabelField,
  trackRecordLabelField,
}) => {
  const [customValue, setCustomValue] = React.useState<string>(recordLabel);
  const [recordLabelErrmsg, setRecordLabelErrmsg] = React.useState<string>('');

  React.useEffect(() => {
    if (!isRecordLabelNameValid(recordLabel)) {
      setRecordLabelErrmsg('LABEL.NAME.ERROR_MESSAGE');
    }
  }, [recordLabel]);

  const handleChange = (value: string) => {
    setCustomValue(value);
    updateRecordLabelField(value);
    trackRecordLabelField(value);

    if (!isRecordLabelNameValid(value)) {
      setRecordLabelErrmsg('LABEL.NAME.ERROR_MESSAGE');
    }
  };

  return (
    <div className={className}>
      <InputField
        label="Record Label Name"
        value={customValue}
        type="text"
        error={
          recordLabelErrmsg !== '' ? <Translate id={recordLabelErrmsg} /> : ''
        }
        onChange={(value) => {
          setRecordLabelErrmsg('');
          handleChange(value);
        }}
      />
      <StyledHint
        noBorderTop
        customTitle={
          <Translate id="RELEASE.NAMES_GENRES.RECORD_LABEL.HINT.TITLE" />
        }
        noMargin
        align="left"
      >
        <Translate id="RELEASE.NAMES_GENRES.RECORD_LABEL.HINT.TEXT" />
      </StyledHint>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordLabelCtrl);

const StyledHint = styled(Hint)`
  margin-top: 3px;
`;
